import { NgReason, ReceiptType } from './receipt'
import { UserRole } from './user'

export type WorkTarget = ReceiptType | 'reMatched' | 'matched'

export type LogParams = {
  dateStartAt: Date
  dateEndAt: Date
  workedById: number | null
  castId: string
  castName: string
  workerType: UserRole | null
  receiptId: number | null
  workTarget: WorkTarget | null
  isModified: IsModified | null
  workResult: WorkResult | null
  approvalResult: ApprovalResult | null
}

export enum LogType {
  RECEIPT = 'receipt',
  SHOP = 'shop',
  ITEM = 'item',
  REMATCH = 'reMatch',
}

// export enum WorkTarget {
//   UNCHECKED = 'unchecked',
//   UNCHECKED_SYSTEM_NG = 'uncheckedSystemNg',
//   LINKER_NG = 'linkerNg',
//   NEW_ITEMS = 'newItems',
//   RE_ITEMS = 'reItems',
//   SYSTEM_NG = 'systemNg',
//   LINKER_CHECKED = 'linkerChecked',
//   LEADER_CHECKED = 'leaderChecked',
//   LEADER_NG = 'leaderNg',
//   SHOP_APPROVAL = 'shopApproval',
// }

export enum WorkResult {
  OK = 'ok',
  NG = 'ng',
  REMATCH = 'reMatch',
  TOBEDELETED = 'toBeDeleted',
  APPROVE = 'approve',
  DELETE = 'delete',
}

export enum ApprovalResult {
  APPROVED = 'approved',
  RE_ITEM = 'reItem',
  DELETE = 'delete',
}

export enum IsModified {
  TRUE = 'true',
  FALSE = 'false',
}

export interface ILog {
  logType: LogType
  workedById: number
  castId: string
  castName: string
  workerType: UserRole
  receiptId: number | null
  workedAt: Date
  workDuration: number
  workTarget: WorkTarget | null
  isModified: IsModified | null
  workResult: WorkResult | null
  approvalResult: ApprovalResult | null
  count: number
  isBasicInfoModified: boolean
  linkedItems: number
  isRewarded: boolean
  ngReasonFrom: NgReason | null
  ngReasonTo: NgReason | null
  note: string
}

export const workerTypes = [
  {
    text: 'admin',
    value: UserRole.ADMIN,
  },
  {
    text: 'leader',
    value: UserRole.LEADER,
  },
  {
    text: 'linker',
    value: UserRole.LINKER,
  },
]

export const workTargets: { text: string; value: WorkTarget }[] = [
  {
    text: '未チェック',
    value: 'unchecked',
  },
  {
    text: '処理残/システムNG',
    value: 'uncheckedSystemNg',
  },
  {
    text: '処理残/リンカーNG',
    value: 'linkerNg',
  },
  {
    text: '処理残/新規紐付商品',
    value: 'newItem',
  },
  {
    text: '処理残/紐付変更商品',
    value: 'reItem',
  },
  {
    text: '処理結果/システムNG',
    value: 'systemNg',
  },
  {
    text: '処理結果/システムOK',
    value: 'systemOk',
  },
  {
    text: '処理結果/リンカーOK',
    value: 'linkerChecked',
  },
  {
    text: '処理結果/リーダーOK',
    value: 'leaderChecked',
  },
  {
    text: '処理結果/リーダーNG',
    value: 'leaderNg',
  },
  {
    text: '店舗登録申請承認',
    value: 'shopUnchecked',
  },
  {
    text: '紐付個別修正',
    value: 'reMatched',
  },
  {
    text: 'マッチ済検索',
    value: 'matched',
  },
]

export const workResults = [
  {
    text: 'OK',
    value: WorkResult.OK,
  },
  {
    text: 'NG',
    value: WorkResult.NG,
  },
  {
    text: 'REMATCH',
    value: WorkResult.REMATCH,
  },
  {
    text: 'TOBEDELETED',
    value: WorkResult.TOBEDELETED,
  },
  {
    text: 'APPROVE',
    value: WorkResult.APPROVE,
  },
  {
    text: 'DELETE',
    value: WorkResult.DELETE,
  },
]

export const approvalResults = [
  {
    text: '承認',
    value: ApprovalResult.APPROVED,
  },
  {
    text: '再紐付',
    value: ApprovalResult.RE_ITEM,
  },
  {
    text: '削除',
    value: ApprovalResult.DELETE,
  },
]

export const isModifieds = [
  {
    text: '有り',
    value: IsModified.TRUE,
  },
  {
    text: '無し',
    value: IsModified.FALSE,
  },
]

export interface IProgress {
  monthly: number
  lastMonth: number | null
  today: number
  yesterday: number | null
}

export interface IProgresses {
  checked: IProgress
  ng: IProgress
  uncheckedSystemNgToLeaderOk: IProgress | null
  uncheckedSystemNgToLeaderNg: IProgress | null
  linkerNgToLeaderOk: IProgress | null
  linkerNgToLeaderNg: IProgress | null
  createdItem: IProgress
  matchedApprove: IProgress
  matchedReMatch: IProgress
  matchedToBeDeleted: IProgress
  matchedDelete: IProgress
  reMatchedApprove: IProgress
  reMatchedReMatch: IProgress
  reMatchedToBeDeleted: IProgress
  reMatchedDelete: IProgress
}
